import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h1", null, "Date and time", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", null, "Set when your event starts and ends.", -1)
const _hoisted_3 = { class: "container" }

import { save, close } from "ionicons/icons";
import {
  IonLabel,
  IonItem,
  IonList,
  IonGrid,
  IonButton,
  IonLoading,
  IonIcon,
  IonSelect,
  IonSelectOption,
  IonRow,
  IonCol,
  IonInput,
  IonFooter,
} from "@ionic/vue";
import { useContextStore } from "@/stores/context";
import { onMounted, reactive } from "vue";
import { editEvent } from "@/api/events";
import { useToasters } from "@/composition/toasters";
import { timezones } from "@/views/Event/";
import { handleError } from "@/views";
import { useWindowWidth } from "@/composition/window";


export default /*#__PURE__*/_defineComponent({
  __name: 'Date',
  emits: ["cancel"],
  setup(__props, { emit }) {



const { isMobile } = useWindowWidth();
const contextStore = useContextStore();
const event = reactive({
  start_date: "",
  end_date: "",
  timezone_id: "",
});
const toasters = useToasters();
const state = reactive({
  loading: true,
});

const loadLocalEvent = () => {
  event.start_date = contextStore.event.start_date.slice(0, -4);
  event.end_date = contextStore.event.end_date.slice(0, -4);
  event.timezone_id = contextStore.event.timezone_id;
};

const submit = () => {
  state.loading = true;
  editEvent({ id: contextStore.event.id, ...event })
    .then(() => {
      state.loading = false;
      toasters.addSuccess("Event info saved successfuly");

      if (isMobile) {
        cancel();
      }
    })
    .catch((err) => {
      state.loading = false;
      handleError(err);
    });
};

const cancel = () => {
  emit("cancel", null);
};

onMounted(() => {
  loadLocalEvent();
  state.loading = false;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", null, [
      _createVNode(_unref(IonItem), null, {
        default: _withCtx(() => [
          _createVNode(_unref(IonLabel), null, {
            default: _withCtx(() => [
              _hoisted_1,
              _hoisted_2
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_unref(IonList), null, {
        default: _withCtx(() => [
          _createVNode(_unref(IonItem), null, {
            default: _withCtx(() => [
              _createVNode(_unref(IonLabel), { position: "stacked" }, {
                default: _withCtx(() => [
                  _createTextVNode(" Start date ")
                ]),
                _: 1
              }),
              _createVNode(_unref(IonInput), {
                modelValue: event.start_date,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((event.start_date) = $event)),
                placeholder: "2022-09-15T06:44:00+01:00",
                type: "datetime-local"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_unref(IonItem), null, {
            default: _withCtx(() => [
              _createVNode(_unref(IonLabel), { position: "stacked" }, {
                default: _withCtx(() => [
                  _createTextVNode("End date")
                ]),
                _: 1
              }),
              _createVNode(_unref(IonInput), {
                modelValue: event.end_date,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((event.end_date) = $event)),
                placeholder: "2022-09-15T06:44:00+01:00",
                type: "datetime-local"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_unref(IonItem), null, {
            default: _withCtx(() => [
              _createVNode(_unref(IonLabel), { position: "stacked" }, {
                default: _withCtx(() => [
                  _createTextVNode("Timezone")
                ]),
                _: 1
              }),
              _createVNode(_unref(IonSelect), {
                placeholder: "Select timezone",
                interface: "popover",
                modelValue: event.timezone_id,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((event.timezone_id) = $event))
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(timezones), (timezone) => {
                    return (_openBlock(), _createBlock(_unref(IonSelectOption), {
                      value: timezone,
                      key: `timezone-${timezone}`
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(timezone), 1)
                      ]),
                      _: 2
                    }, 1032, ["value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      (!_unref(isMobile))
        ? (_openBlock(), _createBlock(_unref(IonButton), {
            key: 0,
            style: {"margin":"20px auto","width":"200px"},
            expand: "block",
            color: "success",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (submit()))
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(IonIcon), {
                slot: "start",
                icon: _unref(save)
              }, null, 8, ["icon"]),
              _createTextVNode(" Save ")
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    (_unref(isMobile))
      ? (_openBlock(), _createBlock(_unref(IonFooter), { key: 0 }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("section", null, [
                _createVNode(_unref(IonGrid), null, {
                  default: _withCtx(() => [
                    _createVNode(_unref(IonRow), null, {
                      default: _withCtx(() => [
                        _createVNode(_unref(IonCol), null, {
                          default: _withCtx(() => [
                            _createVNode(_unref(IonButton), {
                              expand: "block",
                              color: "light",
                              onClick: _cache[4] || (_cache[4] = ($event: any) => (cancel()))
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(IonIcon), {
                                  slot: "start",
                                  icon: _unref(close)
                                }, null, 8, ["icon"]),
                                _createTextVNode(" Cancel ")
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_unref(IonCol), null, {
                          default: _withCtx(() => [
                            _createVNode(_unref(IonButton), {
                              expand: "block",
                              color: "success",
                              onClick: _cache[5] || (_cache[5] = ($event: any) => (submit()))
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(IonIcon), {
                                  slot: "start",
                                  icon: _unref(save)
                                }, null, 8, ["icon"]),
                                _createTextVNode(" Save ")
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ])
            ])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createVNode(_unref(IonLoading), {
      "is-open": state.loading,
      message: "Please wait..."
    }, null, 8, ["is-open"])
  ]))
}
}

})